import React from 'react';
import PropTypes from 'prop-types';

import FormManager from '../../../../gd-form/common/form-manager';

import CustomFieldAddFormProto from "../../add-form-proto";
import CustomFieldLeftPanel from "../../common/panel/form-left-panel";
import CustomFieldPreview from "../../common/form-preview";
import CustomFieldRightPanel from "core/fields/custom/common/panel/form-right-panel";

export default class EmailCustomFieldForm extends CustomFieldAddFormProto {

    static propTypes = {
        customField: PropTypes.object,

        onSubmit: PropTypes.func.isRequired,
    }

    constructor(props) {
        super(props);

        this.type = gd.const.customFields.type.EMAIL;

        this.form = new FormManager(this.formStructure, this.initFormData);
    }

    onSubmit(result) {
        result.name = result.name.trim();
        result.type = gd.const.customFields.type.EMAIL;

        result.params = {
            displayName : result.displayName?.trim(),
            scope       : result.scope
        };

        this.props.onSubmit(result);
    }

    render() {
        return (
            <React.Fragment>
                <CustomFieldLeftPanel parent={this}>
                    <CustomFieldPreview>
                        <div className="txt m-l-15">alex@gmail.com</div>
                    </CustomFieldPreview>
                </CustomFieldLeftPanel>

                <CustomFieldRightPanel parent={this}/>
            </React.Fragment>
        )
    }
}